import { Table, Button } from "antd";
import { ExportOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import { useState } from "react";

function DataTable({
  columns,
  data,
  modalAdd,
  name,
  total,
  loading,
  setSearchPagination,
}: {
  columns: any;
  data: any[];
  modalAdd: any;
  name: string;
  total: number;
  loading: boolean;
  setSearchPagination: any;
}) {
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  let query = `current=${current}&pageSize=${pageSize}`;
  // let query = { current, pageSize };
  setSearchPagination(query);
  const handleExportData = () => {
    if (data.length > 0) {
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(workbook, `Export${name}.csv`);
    }
  };
  const renderHeader = () => {
    return (
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <span>Table List {name}</span>
        <span style={{ display: "flex", gap: 15 }}>
          <Button
            type="primary"
            onClick={() => handleExportData()}
            icon={<ExportOutlined />}>
            Export
          </Button>
          {modalAdd()}
        </span>
      </div>
    );
  };
  const onChange = (pagination: any, filters: any, sorter: any, extra: any) => {
    if (pagination && pagination.current !== current) {
      setCurrent(pagination.current);
    }

    if (pagination && pagination.pageSize !== pageSize) {
      setPageSize(pagination.pageSize);
      setCurrent(1);
    }
  };

  return (
    <Table
      title={renderHeader}
      columns={columns}
      dataSource={data}
      // scroll={{ y: 500 }}
      loading={loading}
      onChange={onChange}
      rowKey={"_id"}
      pagination={{
        current: current,
        pageSize: pageSize,
        showSizeChanger: true,
        total: total,
        showTotal: (total, range) => {
          return (
            <div>
              {range[0]}-{range[1]} trên {total} rows
            </div>
          );
        },
      }}
    />
  );
}

export default DataTable;
